import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  Grid,
  FormLabel,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { getProcessSefazMapa } from "../services/clientService";

interface MAPAModalProps {
  open: boolean;
  onClose: () => void;
  codigo: any;
}

const MAPAModal: React.FC<MAPAModalProps> = ({ open, onClose, codigo }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [resultProcess, setResultProcess] = useState<any>([]);

  const formatarData = (dataISO: any): string => {
    if (!dataISO || typeof dataISO !== "string") return "--";

    const data = new Date(dataISO);
    if (isNaN(data.getTime())) return "--";

    return data.toLocaleDateString("pt-BR");
  };

  const getProcessInfo = async () => {
    setIsLoading(true);
    try {
      const data = await getProcessSefazMapa(codigo);
      setResultProcess(data);
    } catch (err) {
      console.error("Erro ao buscar sefaz e mapa do processo:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      getProcessInfo();
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          bgcolor: "#fff",
          height: "48vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: "#0A0C33",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 2,
          position: "relative",
        }}
      >
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          MAPA
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: "white",
            border: "1px solid white",
            position: "absolute",
            right: 16,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        <Box
          sx={{
            position: "relative",
            m: "16px 16px 16px 16px",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 0.5,
                  fontWeight: 600,
                  textAlign: "left",
                  borderColor: "#0A0C33",
                }}
              >
                Data de Entrada:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={formatarData(resultProcess.DT_ENTRADA_MIN_AGRIC) ?? "--"}
                inputProps={{
                  readOnly: true,
                  style: { textAlign: "center" },
                }}
                style={{ borderRadius: "5px" }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 0.5, fontWeight: 600, textAlign: "left" }}
              >
                Data de Saída:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={formatarData(resultProcess.DT_SAIDA_MIC_AGRIC) ?? "--"}
                inputProps={{
                  readOnly: true,
                  style: { textAlign: "center" },
                }}
                style={{ borderRadius: "5px" }}
              />
            </Grid>
            <Grid item md={12}>
              <Box sx={{ position: "relative", mt: 2 }}>
                <FormControl
                  component="fieldset"
                  sx={{
                    border: "1px solid #0A0C33",
                    borderRadius: "8px",
                    padding: "16px",
                    position: "relative",
                    width: "100%",
                  }}
                >
                  <FormLabel
                    component="legend"
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 16,
                      transform: "translateY(-50%)",
                      backgroundColor: "#fff",
                      px: 1,
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                      color: "#0A0C33",
                    }}
                  >
                    Tipo
                  </FormLabel>

                  <RadioGroup
                    row
                    value={resultProcess.IN_VISTORIA_TRIAGEM_MA ?? "P"}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      flexWrap: "wrap",
                    }}
                  >
                    <FormControlLabel
                      value="V"
                      control={<Radio />}
                      label="Vistoria"
                    />
                    <FormControlLabel
                      value="T"
                      control={<Radio />}
                      label="Triagem"
                    />
                    <FormControlLabel
                      value="P"
                      control={<Radio />}
                      label="Pendente"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                variant="subtitle2"
                sx={{ mb: 0.5, fontWeight: 600, textAlign: "left" }}
              >
                NR Protocolo:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={resultProcess.NR_PROTOCOLO_MA ?? "--"}
                inputProps={{
                  readOnly: true,
                  style: { textAlign: "center" },
                }}
                style={{ borderRadius: "5px" }}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default MAPAModal;
